/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy': {
    width: 16,
    height: 16,
    viewBox: '0 0 47 43',
    data: '<path pid="0" d="M32.07 29.89V10.61a2.14 2.14 0 0 0-2.14-2.14H10.64a2.14 2.14 0 0 0-2.14 2.14v19.28A2.14 2.14 0 0 0 10.64 32h19.29a2.14 2.14 0 0 0 2.14-2.14zm-4.29 0h-15a2.14 2.14 0 0 1-2.14-2.14v-15a2.14 2.14 0 0 1 2.14-2.14h15a2.14 2.14 0 0 1 2.14 2.14v15a2.14 2.14 0 0 1-2.14 2.14zm8.57-15h-2.14V17a2.14 2.14 0 0 1 2.14 2.14v15a2.14 2.14 0 0 1-2.14 2.14h-15a2.14 2.14 0 0 1-2.14-2.14h-2.14v2.14a2.14 2.14 0 0 0 2.14 2.14h19.29a2.14 2.14 0 0 0 2.14-2.14V17a2.14 2.14 0 0 0-2.14-2.14zm0 0"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/copy.js